export enum AppointmentStatus {
  CANCELED = 'canceled',
  NEW = 'new',
  COMPLETED = 'completed',
  CONFIRMED = 'confirmed',
}

export enum PaymentMethod {
  CASH = 'cash',
  VOUCHER = 'voucher',
  CARD = 'card',
}

export interface Client {
  id: number;
  name: string;
  phone_number: string | null;
  notes: string | null;
  appointments?: Appointment[];
}

export interface Hairdresser {
  id: number;
  name: string;
  appointments?: Appointment[];
  timeoffs?: Timeoff[];
}

export interface Discount {
  id: number;
  type: 'percent' | 'fixed';
  amount: string; // decimal as string from backend
}

export interface Service {
  id: number;
  appointment?: Appointment;
  name: string;
  description: string | null;
  price: string; // decimal as string from backend
  duration: number;
  discount?: Discount | null;
}

export interface ServiceTemplate {
  id: number;
  name: string;
  description: string | null;
  estimated_duration: number;
  price: string; // decimal as string from backend
}

export interface Appointment {
  id: number;
  client?: Client;
  hairdresser?: Hairdresser;
  date: Date;
  status: AppointmentStatus;
  notes: string | null;
  services?: Service[];
  payments?: Payment[];
  discount?: Discount | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface Payment {
  id: number;
  method: PaymentMethod;
  amount: number;
  appointment?: Appointment | null;
  soldProduct?: SoldProduct | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface Timeoff {
  id: number;
  hairdresser?: Hairdresser;
  startDate: Date;
  endDate: Date;
  description: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface Product {
  id: number;
  name: string;
  amount: number;
  sell_price: string | null;
  description: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface SoldProduct {
  id: number;
  product: Product;
  amount: number;
  price: number;
  appointment?: Appointment | null;
  client: Client;
  discount?: Discount | null;
  payments?: Payment[];
  createdAt: Date;
  updatedAt: Date;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: PaginationMeta;
}